// Return null when the row lacks enough information to round safely.
// LF coverage must come from the product/order API; it is not the current quantity.
export const roundWallBaseQuantity = (value, data) => {
  const quantity = parseFloat(value);
  if (!Number.isFinite(quantity)) return null;

  const unit = String(data?.unitName || data?.unit || '').trim().toUpperCase();
  let rounded;
  if (unit === 'EA') {
    // Each quantities do not depend on pack coverage.
    rounded = Math.ceil(quantity);
  } else if (unit === 'LF') {
    const coverage = parseFloat(data?.coverage ?? data?.Coverage ?? data?.productCoverage);
    if (!Number.isFinite(coverage) || coverage <= 0) return null;
    rounded = Math.ceil(quantity / coverage) * coverage;
  } else {
    return null;
  }

  return Number.isFinite(rounded) ? rounded.toFixed(2) : null;
};
